import Request from "../lib/request";
import {
  ACTIVE_PLANS_API,
  CALCULATE_PRICE_API,
  INIT_API,
  PAY_API,
  PREMIUM_API,
  PROMO_CODES_API,
  PURCHASE_TRANSACTIONS_API
} from "../constants/api";
import {PAGE} from "../constants/filters";

const baseUrl = process.env.REACT_APP_API_URL;

export const init = (data) => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PREMIUM_API}/${INIT_API}`,
    needToken: true,
    params:data
  });
};

export const calculatePrice = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${PREMIUM_API}/${CALCULATE_PRICE_API}`,
    needToken: true,
    data
  });
};

export const getList = page_number => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PREMIUM_API}/${PURCHASE_TRANSACTIONS_API}?${PAGE}=${page_number}`,
    needToken: true
  });
};

export const getByProject = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/premium/transactionsByProject`,
    needToken: true
  });
};

export const payStore = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${PREMIUM_API}/${PAY_API}`,
    needToken: true,
    data: data
  });
};

export const getPromoCode = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PREMIUM_API}/${PROMO_CODES_API}`,
    needToken: true
  });
};

export const getActivePlans = ownerId => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PREMIUM_API}/${ACTIVE_PLANS_API}?owner_id=${ownerId}`,
    needToken: true
  });
};

export const freePlan = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/premium/freePlan`,
    needToken: true
  });
};

export const getTransaction = id => {
  return Request({
    method: "get",
    url: `${baseUrl}/${PREMIUM_API}/${PURCHASE_TRANSACTIONS_API}/${id}`,
    needToken: true
  });
};
